import fs from 'fs';
import nock, { Definition, Scope } from 'nock';
import path from 'path';
import { Request, RequestHandler, Response } from 'express';
import { MigrateRequest } from '~/services';
import { hexToString } from '~/util/hex';
import { LIB_VERSION } from '~/util/version';

export const USE_MOCKS =
  process.env.USE_MOCKS === 'true' ||
  process.env.npm_config_USE_MOCKS === 'true';

export let RECORD_MOCKS = !!process.env.RECORD_MOCKS;

const RECORD_PATH = '../../nock/recorded';

export const startRecorder = (record = false) => {
  RECORD_MOCKS = record;

  if (RECORD_MOCKS) {
    nock.recorder.rec({
      dont_print: true,
      output_objects: true,
      // enable_reqheaders_recording: true,
    });
    console.info('[nock] recording requests to save for later');
  }
};

export const saveRecorded = (
  req: Request,
  res: Response,
  {
    operation,
    response,
  }: {
    operation: string;
    response: any;
  }
) => {
  if (!RECORD_MOCKS && USE_MOCKS) {
    if (nock.pendingMocks().length > 0) {
      console.error('[nock] pending mocks: %j', nock.pendingMocks().length);
      nock.pendingMocks().map((pm) => {
        console.info(' %j', pm);
      });
    }
    nock.enableNetConnect();
  }

  if (RECORD_MOCKS && operation) {
    const nockCalls = nock.recorder.play();
    nock.recorder.clear();

    const preview = res.locals.preview;

    const recorded: {
      url: string;
      payload: MigrateRequest;
      preview: boolean;
      operation: string;
      response: any;
      nockCalls: string[] | Definition[];
    } = {
      url: req.originalUrl,
      operation,
      payload: res.locals.payload,
      preview: res.locals.preview,
      response,
      nockCalls,
    };

    const filename = path.join(
      __dirname,
      RECORD_PATH,
      `/${req.originalUrl
        .replace('/v1/', '')
        .replace(/\//g, '_')
        .replace(/&/g, '_')
        .replace(/[?]/g, '_')}${preview ? '_preview' : ''}.json`
    );

    console.info(
      `[nock recorder] Writing ${nockCalls?.length} recorded mocks to '${filename}'`
    );

    fs.writeFileSync(
      filename,
      JSON.stringify(recorded).replace(
        new RegExp(LIB_VERSION, 'g'),
        '0.0.1-test'
      )
    );
  }
};

const recordedPath = path.join(__dirname, RECORD_PATH);

export const loadRecorded = () => {
  const files = fs.readdirSync(recordedPath);
  return files.map((fileName) => loadRecordedMock(fileName));
};

export const loadRecordedMock = (fileName: string) => {
  return JSON.parse(
    fs
      .readFileSync(path.join(recordedPath, fileName), 'utf8')
      .replace(/0.0.1-test/g, LIB_VERSION)
  );
};

export const mockingMiddleware = () => {
  // if (true && !RECORD_MOCKS) {
  if (USE_MOCKS && !RECORD_MOCKS) {
    const mocks = loadRecorded();

    const loadMocks: RequestHandler = (req, res, next) => {
      nock.cleanAll();
      nock.enableNetConnect();
      const { payload, preview } = res.locals;
      const mock = mocks.find(
        (m) => m.url === req.originalUrl && m.preview === preview // &&
        // JSON.stringify(m.payload) === JSON.stringify(payload)
      );
      if (mock && 'nockCalls' in mock) {
        if (nock.pendingMocks().length > 0)
          console.warn('[nock] pending mocks: %j', nock.pendingMocks().length);
        console.info(`[nock] found mocks for ${mock.url}`);
        nock.define(
          mock.nockCalls.map((nc: Scope) => ({
            ...nc,
            filteringRequestBody: function (
              body: string,
              recordedBody: string
            ) {
              // Workaround for multipart/formdata requests not matching
              // due to random numbers wrapping the formdata, for example:
              // `----------------------------584350325479384276732951\r\nContent-Disposition: form-data; name="file"; filename="swiss-army-knife-blog-image1.jpeg"\r\n...`
              if (
                body.startsWith('2d2d2d') ||
                ((this as any).interceptors[0].path.startsWith(
                  '/api/management/projects/'
                ) &&
                  (this as any).interceptors[0].path.endsWith('/assets'))
              ) {
                const multipartFormBody = hexToString(body);
                const multipartFormRecorded = hexToString(recordedBody);
                // Parse the raw hex body and match the string for example
                // `Content-Disposition: form-data; name="file"; filename="swiss-army-knife-blog-image1.jpeg"`
                if (
                  multipartFormBody.split('\r\n')[1] ===
                  multipartFormRecorded.split('\r\n')[1]
                ) {
                  return recordedBody;
                }
              }
              return body;
            },
            // options: { allowUnmocked: true },
          }))
        );

        nock.disableNetConnect();
        // console.info('[nock] pending mocks: ');
        // nock.pendingMocks().map((pm) => {
        //   console.info(' %j', pm);
        // });
        console.info('[nock] loaded mocks: %j', nock.pendingMocks().length);
      } else {
        console.info('[nock] no mocks found, using real api');
      }
      // nock.recorder.play();
      next();
    };
    return loadMocks;
  } else {
    const dontUseMockData: RequestHandler = (req, res, next) => next();
    return dontUseMockData;
  }
};
